import {isGDSystemLink} from "./gd-system-link";

const debug = false
// const debug = "EmbedUtils"

export default class EmbedUtils {

    static isLink(value: string) {

        // it allows internal GD links i.e. gd://request-form/xxxx
        if (isGDSystemLink(value)) return true

        // Regular expression for URL validation
        const urlRegex = /^(?:(https?):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i

        // Test the given String against the regex
        return urlRegex.test(value)
    }

    static isLinkV2(value: string) {

        // it allows internal GD links i.e. gd://request-form/xxxx
        if (isGDSystemLink(value)) return true

        // Regular expression for URL validation
        const urlRegex = /^(?:(?:https?|ftp|file):\/\/)(?:www\.)?(?:(?:[a-zA-Z0-9\u00a1-\uffff][a-zA-Z0-9\u00a1-\uffff-]{0,62}\.)+[a-zA-Z\u00a1-\uffff]{2,}|(?:\d{1,3}\.){3}\d{1,3}|\[[a-fA-F0-9:]+\])(?::\d{1,5})?(?:[\/?#][^\s]*)?$/i

        // Test the given String against the regex
        return urlRegex.test(value)
    }

    static isIFrame(value: string) {
        // Regular expression for IFrame validation
        const iframeRegex = /^<iframe(.|\n|\r)+<\/iframe>$/i

        // Test the given String against the regex
        return iframeRegex.test(value)
    }

    static getLinkSource(value: string) {
        // Regular expression for URL validation
        const urlRegex = /^(?:(https?):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i

        // find match in the given String according the regex
        const match = value.match(urlRegex)
        return match ? match[0] : null
    }

    static getIFrameSource(value: string) {
        // Regular expression for URL validation
        const urlRegex = /src=(["'])(?<url>(?:https?:)?\/\/(?:(?!\1).)*?)\1/i

        // find match in the given String according the regex
        const match = value.match(urlRegex)

        debug && console.log(debug, 'getIFrameSource', match, value)

        return match ? match[0] : null
    }
}
